var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.84546C6.61522 2.84546 2.25 7.21068 2.25 12.5955C2.25 17.9802 6.61522 22.3455 12 22.3455C17.3848 22.3455 21.75 17.9802 21.75 12.5955C21.75 7.21068 17.3848 2.84546 12 2.84546ZM16.2803 13.1258C16.421 12.9851 16.5 12.7944 16.5 12.5955C16.5 12.3965 16.421 12.2058 16.2803 12.0651L13.2803 9.06513C12.9874 8.77224 12.5126 8.77224 12.2197 9.06513C11.9268 9.35802 11.9268 9.8329 12.2197 10.1258L13.9393 11.8455L8.25 11.8455C7.83579 11.8455 7.5 12.1812 7.5 12.5955C7.5 13.0097 7.83579 13.3455 8.25 13.3455L13.9393 13.3455L12.2197 15.0651C11.9268 15.358 11.9268 15.8329 12.2197 16.1258C12.5126 16.4187 12.9874 16.4187 13.2803 16.1258L16.2803 13.1258Z",
    fill: "#252424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4a3d7421d81bd57564ca06fd860044c3.svg";
export { ForwardRef as ReactComponent };